import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import WhatIsSuperbuySpreadsheet from "../pages/article-what-is/page";
import BestSuperbuySpreadsheetBeginners from "../pages/article-beginners/page";
import HowToUseSuperbuySpreadsheet from "../pages/article-how-to-use/page";
import SuperbuySpreadsheetSaveMoney from "../pages/article-save-money/page";
import BestSneakerSuperbuySpreadsheet from "../pages/article-sneaker/page";
import BestClothingSuperbuySpreadsheet from "../pages/article-clothing/page";
import DesignerBrandsSuperbuySpreadsheet from "../pages/article-designer/page";
import SuperbuyShippingGuide from "../pages/article-shipping/page";
import ReduceSuperbuyShippingCosts from "../pages/article-shipping-costs/page";
import SuperbuyAgentComparisonGuide from "../pages/article-agent-comparison/page";
import SuperbuySafetyGuide from "../pages/article-safety/page";
import SuperbuyFAQ from "../pages/article-faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/what-is-superbuy-spreadsheet/",
    element: <WhatIsSuperbuySpreadsheet />,
  },
  {
    path: "/best-superbuy-spreadsheet-beginners/",
    element: <BestSuperbuySpreadsheetBeginners />,
  },
  {
    path: "/how-to-use-superbuy-spreadsheet/",
    element: <HowToUseSuperbuySpreadsheet />,
  },
  {
    path: "/superbuy-spreadsheet-save-money/",
    element: <SuperbuySpreadsheetSaveMoney />,
  },
  {
    path: "/best-sneaker-superbuy-spreadsheet/",
    element: <BestSneakerSuperbuySpreadsheet />,
  },
  {
    path: "/best-clothing-superbuy-spreadsheet/",
    element: <BestClothingSuperbuySpreadsheet />,
  },
  {
    path: "/designer-brands-superbuy-spreadsheet/",
    element: <DesignerBrandsSuperbuySpreadsheet />,
  },
  {
    path: "/superbuy-shipping-guide/",
    element: <SuperbuyShippingGuide />,
  },
  {
    path: "/reduce-superbuy-shipping-costs/",
    element: <ReduceSuperbuyShippingCosts />,
  },
  {
    path: "/superbuy-agent-comparison-guide/",
    element: <SuperbuyAgentComparisonGuide />,
  },
  {
    path: "/superbuy-safety-guide/",
    element: <SuperbuySafetyGuide />,
  },
  {
    path: "/superbuy-faq/",
    element: <SuperbuyFAQ />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;